export default __webpack_public_path__ + "alberta-lock.3d47c7593766d2874821.svg";